import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormHelper } from '@helpers/form.helper';
import { ValidatorHelper } from '@helpers/validators.helper';
import { ErrorMessage } from '@interfaces/error-message';
import { ExternalLink } from '@models/external-link';

export type ExternalLinkFormType = {
  id: FormControl<number>;
  name: FormControl<string>;
  url: FormControl<string>;
};

export class ExternalLinkForm extends FormGroup<ExternalLinkFormType> {
  get id(): FormControl<number> {
    return this.controls.id;
  }

  get name(): FormControl<string> {
    return this.controls.name;
  }

  get nameErrorMessage(): ErrorMessage {
    return FormHelper.getEmptyErrorMessage(this.name, 'Titre requis.');
  }

  get url(): FormControl<string> {
    return this.controls.url;
  }

  get urlErrorMessage(): ErrorMessage {
    return FormHelper.composeErrorMessages(this.url, [
      { method: 'getEmptyErrorMessage', args: ['Url requise.'] },
      {
        method: 'simpleErrorMessage',
        args: [
          {
            simpleErrorCode: ValidatorHelper.urlErrorName,
            simpleErrorMessage: 'Url invalide, (Format accepté: https://xxx.xxx).'
          }
        ]
      }
    ]);
  }

  constructor() {
    super({
      id: new FormControl<number>(null),
      name: new FormControl<string>(null, Validators.required),
      url: new FormControl<string>(null, [Validators.required, ValidatorHelper.urlValidator()])
    });
  }

  fromExternalLink(externalLink: ExternalLink): void {
    this.patchValue({
      id: externalLink.id,
      name: externalLink.name,
      url: externalLink.url
    });
  }

  toExternalLink(): ExternalLink {
    return new ExternalLink(this.id.value, this.name.value, this.url.value);
  }
}
